import { render, staticRenderFns } from "./AppsDashboard.vue?vue&type=template&id=4ec8dd1c&scoped=true&"
import script from "./AppsDashboard.vue?vue&type=script&lang=js&"
export * from "./AppsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AppsDashboard.vue?vue&type=style&index=0&id=4ec8dd1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8dd1c",
  null
  
)

export default component.exports